import React, { FC, Fragment, useContext } from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'utils/format';
import { CurrencyContext } from 'context/currency';

type PriceProps = {
    price: number;
    label: string;
    warranty?: boolean;
};

const Price: FC<PriceProps> = ({ price, label, warranty }: PriceProps) => {
    const { t: translate } = useTranslation();
    const { currency } = useContext(CurrencyContext);

    return (
        <Fragment>
            <PriceTagChip>
                {translate(label)}:&nbsp;
                {formatCurrency(warranty ? 0 : price, currency)}
            </PriceTagChip>
        </Fragment>
    );
};

const PriceTagChip = styled(Box)(() => ({
    background: '#e0e0e0',
    padding: '10px 25px',
    borderRadius: 4,
    fontWeight: 600,
    marginLeft: 'auto',
}));

export default Price;
